<template>
    <div id="app">
        <svg-sprite></svg-sprite>
        <v-app>
            <notifications group="notifications" classes="notification" position="top right">
                <template slot="body" slot-scope="props">
                    <div :class="['notification', props.item.type]">
                        <div class="notification-title">{{ props.item.title }}</div>
                        <div class="notification-content">{{ props.item.text }}</div>

                        <div class="notification-event" v-if="'event' == props.item.type">
                            <div class="close" @click="props.close">
                                <i class="material-icons">close</i>
                            </div>
                            <div class="header">
                                Event
                            </div>
                            <div class="event-wrapper">
                                <div :class="['event-type', props.item.data.eventType.name.toLowerCase() || '' ]"  @click="showEvent(props.item.data.id)">{{ props.item.data.eventType.name || 'Unknown' }}</div>
                                <div class="details">
                                    <div class="date">{{ date(props.item.data.dateRaised) }}</div>
                                    <div class="axis">X: {{ props.item.data.xAxis }} Y: {{ props.item.data.yAxis }} Z: {{ props.item.data.zAxis }}</div>
                                </div>
                                <div class="details">
                                    <div class="car">{{ props.item.data.driverName || 'Any' }} / {{ props.item.data.vehicleRegistrationNumber || 'Unknown' }}</div>
                                </div>
                                <div class="details">
                                    <div class="speed-text">Speed at the time</div>
                                    <div class="speed-value">{{ props.item.data.speed }} mph</div>
                                </div>
                            </div>
                        </div>

                        <div class="notification-snapshot" v-if="'snapshot' == props.item.type">
                            <div class="close" @click="props.close">
                                <i class="material-icons">close</i>
                            </div>
                            <div class="header">
                                {{ props.item.data.snapshotType.name }}
                            </div>
                            <div class="event-wrapper">
                                <div :class="[props.item.data.snapshotType.name.toLowerCase()]" @click="showSnapshot(props.item.data.id)">Requested: {{ date(props.item.data.createdOn) }}</div>
                                <div class="details">
                                    <div class="date">{{ date(props.item.data.createdOn) }}</div>
                                </div>
                                <div class="details">
                                    <div class="car">{{ props.item.data.driverName || 'Any' }} / {{ props.item.data.vehicleRegistrationNumber || 'Unknown' }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="notification-device-command" v-if="'deviceCommandState' == props.item.type">
                            <div class="close" @click="props.close">
                                <i class="material-icons">close</i>
                            </div>
                            <button v-if="props.item.data.eventId" class="notification-button" @click="showEvent({ eventId: props.item.data.eventId, hardwareId: props.item.data.hardwareId }, props.close)">Open modal</button>
                        </div>
                    </div>

                </template>
            </notifications>

            <router-view :key="`default-view-${this.getActiveOrganization}`">
            </router-view>
        </v-app>
    </div>
</template>

<script>
import { formatDate } from './helpers/Utils'
import { mapGetters } from 'vuex'
import SvgSprite from '@/components/atoms/SvgSprite'

export default {
    name: 'App',
    components: {
        SvgSprite
    },
    methods: {
        date (value) {
            return formatDate(value)
        },
        showSnapshot (snapshotId) {
            this.$store.commit('setSnapshotId', snapshotId)
        },
        showEvent (payload, callback) {
            this.$store.commit('setEventId', payload)
            callback()
        }
    },
    computed: {
        ...mapGetters('authModule', [
            'getActiveOrganization'
        ])
    }
}
</script>

<style lang="scss">
@import "assets/scss/app";
</style>
